export const journeyData = {
    breakthroughBasics: [
        {
            week: "b1",
            actionSteps: ["Watch Breakthrough Basics videos 1 & 2"],
            videos: [
                {
                    title: "Welcome to Breakthrough M2",
                    link: "https://player.vimeo.com/video/849761866?h=a14d2163da&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
                },
                {
                    title: "History, Science, & Math",
                    link: "https://www.youtube.com/embed/6rvTyNP50f8?si=z_UoOReQWGuyLrzP",
                    bottomLinkText: "Dr. Simeons' Protocol",
                    bottomLink:
                        "https://alulawellness.com/wp-content/uploads/2018/02/DrSimeonsProtocol.pdf",
                },
            ],
        },
        {
            week: "b2",
            actionSteps: [
                "Watch Breakthrough Basics videos 3 & 4",
                "Connect on Team Breakthrough M2 on Facebook",
            ],
            videos: [
                {
                    title: "The Little Known Secret About Fat",
                    link: "https://www.youtube.com/embed/JhKJFMcN9uQ?si=Fw6vTihM8b7g7CP_",
                },
                {
                    title: "Why are we different? Our Drops.",
                    link: "https://www.youtube.com/embed/6DmbaVY7Nls?si=JiuZtIVlsrYLV4Ad",
                    bottomLinkText: "BTM2 Drops Ingredients List",
                    bottomLink:
                        "https://alulawellness.com/wp-content/uploads/2023/09/The-BTM2-Drops-Ingredients-PDF.pdf",
                },
            ],
        },
        {
            week: "b3",
            actionSteps: [
                "Watch Breakthrough Basics videos 5 & 6",
                "Follow us on any other Social Media Platforms you plug into",
            ],
            videos: [
                {
                    title: "The 4 Steps to Success",
                    link: "https://www.youtube.com/embed/RrWhv0Kon7M?si=-wvksgXwf7RQ7dRl",
                    bottomLinkText: "Fat Loss Food List",
                    bottomLink:
                        "https://alulawellness.com/wp-content/uploads/2023/09/Food-List-PDF.jpg",
                },
                {
                    title: "A Day in The Diet Video",
                    link: "https://www.youtube.com/embed/_pcuh-yk7sM?si=XwxTR_Hebsl9CxmE",
                },
            ],
        },
        {
            week: "b4",
            actionSteps: ["Watch Breakthrough Basics videos 7 & 8"],
            videos: [
                {
                    title: "Weight Loss Expectations ",
                    link: "https://www.youtube.com/embed/S8lXxvV09uM?si=LUwNqxaValzWWluS",
                },
                {
                    title: "It's Decision Time! ",
                    link: "https://player.vimeo.com/video/853826423?h=6d89964d6b",
                },
            ],
        },
    ],
    step1: [
        {
            week: "1a",
            actionSteps: [
                "Watch Breakthrough videos 1 & 2",
                "With the guidance of your BTM2 Manual, add healthy fats to your meals this week.",
                "Calculate your water amount and practice drinking!.",
                "Get organized by using the inserts in your BTM2 Folder.",
            ],
            videos: [
                {
                    title: "Action Steps for the 5 prep days",
                    link: "https://www.youtube.com/embed/HG5GB7LX3EU?si=Km8HvGCysoFkpXum",
                },
                {
                    title: "Low Cal Basics",
                    link: "https://youtu.be/JM0vmeCwVFY?si=sWmJdPdqPp1uInQS",
                },
            ],
            bonusSteps: [],
        },
        {
            week: "1aa",
            actionSteps: [
                "Watch Breakthrough videos 3 & 4",
                "Create your shopping list! Hint: A Shopping List Maker is in your BTM2 Folder.",
                "Organize your refrigerator and pantry for the BTM2 Program!",
            ],
            videos: [
                {
                    title: "Food Lists FAQ's",
                    link: "https://www.youtube.com/embed/8lJWgDEYSsg?si=p-xKt2Qc65pCYGtC",
                },
                {
                    title: "Cooking Rules & Guidelines",
                    link: "https://www.youtube.com/embed/74KVs4xlCQo?si=AZdpunRNyTtPl6A9",
                },
            ],
            bonusSteps: [],
        },
        {
            week: "1ab",
            actionSteps: [
                "Watch Breakthrough videos 5 & 6",
                "Print your Weekly Photo Stamps here.",
                "Holding your Prep Week Photo Stamp, take your first pictures, including front, back, and side views.",
                "Upload your starting photos to your BTM2 Dashboard.",
            ],
            videos: [
                {
                    title: "Weight Loss Expectations",
                    link: "https://www.youtube.com/embed/J3sxM1llOtc?si=G7oxSPS0MLR5CrXw",
                },
                {
                    title: "Supplements for Low Cal and Beyond",
                    link: "https://www.youtube.com/embed/aM1w1nG-vLg?si=48Xkv7S7flJ-Hk21",
                },
            ],
            bonusSteps: [],
        },
        {
            week: "1ac",
            actionSteps: [
                "Watch Breakthrough videos 7 & 8",
                "Schedule your Coach Call",
            ],
            videos: [
                {
                    title: "Detoxification on Step 2",
                    link: "https://www.youtube.com/embed/j5eFEieTMrk?si=8BJefZQCLLWjcLKE",
                },
                {
                    title: "Exercise on Step 2 ",
                    link: "https://www.youtube.com/embed/itaunzsphAE?si=-zaP72l11Jg8tZRK",
                },
            ],
            bonusSteps: [],
        },
        {
            week: "1ad",
            actionSteps: ["Watch Breakthrough videos 9 & 10"],
            videos: [
                {
                    title: "Medications & Fat Loss",
                    link: "https://www.youtube.com/embed/lQGMsqWoah0?si=jSo8vTto6o5YZ69W",
                },
                {
                    title: "Fat Flush w/Water Drinking",
                    link: "https://www.youtube.com/embed/twEWUD6ZGa0?si=H1mu9lzxLz5hBVNK",
                },
            ],
            bonusSteps: [],
            // bonusSteps: ["Subscribe to our social media profile"],
        },
        {
            week: "1ae",
            actionSteps: ["Watch Breakthrough videos 11 & 12"],
            videos: [
                {
                    title: "Action Steps for the 2 High Fat Days",
                    link: "https://www.youtube.com/embed/JM0vmeCwVFY?si=Key-30X8gdaifFIr",
                },
                {
                    title: "How to use the Weight Loss Drops",
                    link: "https://www.youtube.com/embed/dEOFImehETA?si=D91oVDSp3a3m9YAi",
                },
            ],
            bonusSteps: [],
            // bonusSteps: ["Subscribe to our social media profile"],
        },
        {
            week: "1b",
            actionSteps: [
                "Record your starting weight.",
                "Take the BTM2 Drops three times per day as directed in your BTM2 Manual.",
                "Eat a lot of high-fat food. Your BTM2 Manual has suggestions. Eat, Drink, and Be Merry!",
                "Take the BTM2 Drops three times per day as directed in your BTM2 Manual.",
                "Eat a lot of high-fat food. Your BTM2 Manual has suggestions. Eat, Drink, and Be Merry!",
                "Prep your 14-14-14 (proteins-vegetables-fr uits)",
                "Finish reading Steps 1 & 2 in your BTM2 Manual.",
                "Did you gain 3-5 during the 2 high fat days?",
            ],
            videos: [],
            bonusSteps: [],
            // bonusSteps: ["Subscribe to our social media profile"],
        },
    ],
    step2: [
        {
            week: 2,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
        },
        {
            week: 3,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Check out the BTM2 Kudos Board",
            //   "Did you define your Weight Loss Why?",
            // ],
        },
        {
            week: 4,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Check out the BTM2 Recipes and Videos",
            //   "Re-Read the weight loss expectations in your manual.  Are you within the averages?",
            //   "If you need to, bring this up on your next coaching call.",
            // ],
        },
        {
            week: 5,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Refer a friend?",
            //   "Check out the BTM2 Referral program and Referral Contest!",
            //   "Please Take our Coach Survey.",
            //   "Invite a friend to Team Breakthrough M2.",
            // ],
        },
        {
            week: 6,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Actions for Sustainability!",
            //   "Do something out of your comfort zone, post a pic on Team Breakthrough or the Kudos Board!",
            // ],
        },
        {
            week: 7,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Actions for Sustainability!",
            //   "Take pictures of you in some of your old clothes and post them!",
            //   "Then...box them up for donation!",
            // ],
        },
        {
            week: 8,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Actions for Sustainability!",
            //   "Check out this blog",
            //   "Check out this video",
            // ],
        },
        {
            week: 9,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Actions for Sustainability!",
            //   "Check out this blog",
            //   "Check out this video",
            // ],
        },
        {
            week: 10,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Actions for Sustainability!",
            //   "Check out this blog",
            //   "Check out this video",
            // ],
        },
        {
            week: 11,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Actions for Sustainability!",
            //   "Check out this blog",
            //   "Check out this video",
            // ],
        },
        {
            week: 12,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Actions for Sustainability!",
            //   "Check out this blog",
            //   "Check out this video",
            // ],
        },
        {
            week: 13,
            actionSteps: [
                "Use your Daily Habit Tracker.",
                "Holding your Weekly Photo Stamp, take your pictures, including front, back, and side views.",
                "Upload your weekly photos to your BTM2 Dashboard.",
                "Schedule your Coach Call and/or Attend a Group Coach Session.",
                "Take and record your inches.",
            ],
            videos: [
                // {
                //     title: "Water Limits",
                //     link: "https://player.vimeo.com/video/897082313?h=a8eb1e9272&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Group Coaching ",
                //     link: "https://player.vimeo.com/video/897288674?h=e9088088a9&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Team BTM2",
                //     link: "https://player.vimeo.com/video/897289340?h=793cb2ea87&title=0&byline=0&portrait=0",
                // },
                // {
                //     title: "Referral Program ",
                //     link: "https://player.vimeo.com/video/897290003?h=33329e917d&title=0&byline=0&portrait=0",
                // },
                {
                    title: "Establish your Wellness Why",
                    link: "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                    bottomLinkText: "BTM2 Weight Loss Why worksheet",
                    bottomLink:
                        "https://dashboard.alulawellness.com/breakthrough-uploads/BTM2-Weight-Loss-Why-worksheet.pdf",
                },
            ],
            bonusSteps: [],
            // bonusSteps: [
            //   "Actions for Sustainability!",
            //   "Check out this blog",
            //   "Check out this video",
            // ],
        },
    ],
    step3: [
        {
            week: 14,
            actionSteps: [
                "No BTM2 Drops",
                "Stay on the Step 2 low-cal meal plan.",
                "No BTM2 Drops",
                "Stay on the Step 2 low-cal meal plan.",
                "Begin watching Step 4 videos",
                "Read Steps 3 & 4 in your BTM2 Manual.",
            ],
            videos: [
                {
                    title: "Step 3: Stabilize",
                    link: "https://www.youtube.com/embed/q13f6mYgLNk?si=9l4pgw_ma_XR1CSy",
                },
                {
                    title: "Step 3: Interim",
                    link: "https://www.youtube.com/embed/aqvlISdUMGs?si=xfI9PCQHX6uYrzhZ",
                },
            ],
        },
    ],
    step4: [
        {
            week: 15,
            actionSteps: [
                "Watch Step 4 Transition Videos 1 & 2",
                "Read the Step 4 section in your BTM2 Manual.",
                "Continue your daily water intake.",
                "Continue to record your daily weight.",
            ],
            videos: [
                {
                    title: "Step 4: Transition Basics",
                    link: "https://www.youtube.com/embed/WJfTjY0h7xI?si=wEIQaKNGlUZ4dubD",
                },
                {
                    title: "Step 4: The 1-2-3 Menu Plan",
                    link: "https://www.youtube.com/embed/AhzUtzmMP6A?si=Twqe0sOoUUUuRth2",
                },
            ],
        },
        {
            week: 16,
            actionSteps: [
                "Watch Step 4 Transition Videos 3 & 4",
                "Finish reading the Step 4 section in your BTM2 Manual.",
                "Continue your daily water intake.",
                "Continue to record your daily weight.",
            ],
            videos: [
                {
                    title: "Step 4: Healthy Habits & What to Watch For",
                    link: "https://www.youtube.com/embed/eR3wvOwRmPM?si=SS6AhATR7_w_Z5Oe",
                },
                {
                    title: "Step 4 and Beyond: Eating Right For Your Type",
                    link: "https://www.youtube.com/embed/5yxSUgtkpk0?si=U8dsiB_hKIBXmFxS",
                },
            ],
        },
        {
            week: 17,
            actionSteps: [
                "Upload your Final Before-After Photo and Testimonial.",
                "Schedule your Success Scream.",
                "Give us a Google Review.",
                "Give us a Facebook Review.",
            ],
            videos: [
                {
                    title: "Step 4: Transition Seminar",
                    link: "https://www.youtube.com/embed/LR5L9tdAP6E?si=InIGA6x4ssJieTow",
                },
            ],
        },
        {
            week: 18,
            actionSteps: [
                "Watch the 90/10 video & the final message from Nan!",
            ],
            videos: [
                {
                    title: "Step 5 - 90/10 Living",
                    link: "https://www.youtube.com/embed/tUAn4-4Ajbg?si=r-nnidol5iQVTgyt",
                },
                {
                    title: "A final message from Nan!",
                    link: "https://www.youtube.com/embed/yw8oUNPzt68?si=ZHn4iqv3xal6AtHm",
                },
            ],
        },
    ],
};

export const journeyLables = {
    breakthroughBasics: "BTM2 Basics",
    step1: "Step 1 - Prep week",
    step2: "Step 2 - Fat Loss Phase",
    step3: "Step 3 - Stabilize",
    step4: "Step 4 - Transition",
};
